import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <p>Under construction. Please come back and visit soon.</p>
  </Layout>
)

export default IndexPage
